import React from 'react'

import triggerEvent from 'utils/dataLayer'
import Button from 'components/atoms/Button'

const UnauthorizedMenu = () => (
  <div className="navbar-unauthorized-menu">
    <Button
      tag="a"
      kind="medium"
      href="/signup"
      variant="secondary"
      className="navbar-unauthorized-menu__btn"
      onClick={() => triggerEvent('ga/global/button-navbar/signup')}
    >
      Daftar
    </Button>
    <Button
      tag="a"
      kind="medium"
      href="/signin"
      variant="default"
      className="navbar-unauthorized-menu__btn"
      onClick={() => triggerEvent('ga/global/button-navbar/signin')}
    >
      Masuk
    </Button>
    <style jsx>
      {`
        .navbar-unauthorized-menu {
          display: none;

          height: 100%;
          :global(&__btn) {
            margin: 0;
            height: 100%;
            padding: 0 24px;

            display: inline-flex;
            align-items: center;
            justify-content: center;

            font-size: 1rem;
            font-weight: bolder;

            &:first-of-type {
              margin-right: 8px;
              color: #1A344F;
              border: solid 1px #A3B4CA;
            }
          }
          @media screen and (min-width: 768px) {
            display: block;
          }
        }
      `}
    </style>
  </div>
)

export default UnauthorizedMenu
